import React, { useContext, useEffect, useRef } from 'react';
import { Grid } from '@material-ui/core';
import { useRouteMatch, useLocation } from 'react-router-dom';
import Media from 'react-media';
import $ from 'jquery';
// import RightLateralBar from '../../components/RightLateralBar';
import LeftLateralBar from '../../components/LeftLateralBar';
import HeaderView from '../../components/HeaderView';
import ModalCollection from '../../components/ModalCollection';
import DeliveryView from '../../components/DeliveryView';
import TakeAwayView from '../../components/TakeAwayView';
import PrintView from '../../components/PrintView';
import CategoryView from '../../components/CategoryView';
import DeliveriesMobile from '../../pagesMobile/DeliveriesMobile';
import useConfigContext from '../../hooks/useConfigContext';
import { exportProducts, exportImages } from './api';
import { ProductContext } from '../../contexts/products';
import { ImagesToExportContext } from '../../contexts/imagesToExport';
import api from '../../services/api';

/* eslint eqeqeq: "off" */
const dictIdDelivery = {
  1: '5f34a6b5ed5ff21fbc9939c6',
  2: '5f34a7b6bc82e351349c76bf',
  3: '5f34a7c2bc82e351349c76c0',
};

const productObjectToFilter = {
  delivery: 'MAIN',
  swimwear: 'SWIMWEAR',
  shoes: 'FOOTWEAR',
  men: 'MENSWEAR',
};
function Deliveries() {
  const { configState } = useConfigContext();
  const { params } = useRouteMatch();
  const { delivery_id, view } = params;
  const [open, setOpen] = React.useState(false);
  const [showDND, setShowDND] = React.useState(false);
  const [isCategoryDetail, setIsCategoryDetail] = React.useState(false);

  const location = useLocation();
  const [bg, setBg] = React.useState(true);
  const splittedLocation = location.pathname.split('/');
  // eslint-disable-next-line prefer-destructuring
  const currentCollection = splittedLocation[1];

  // CONTEXTO PRODUTO
  const { setExported } = useContext(ProductContext);

  // CONTEXTO EXPORTAÇÕES IMAGENS
  const { setBtnText, imagesToExport } = useContext(ImagesToExportContext);

  const handleIsCategoryDetail = React.useCallback(value => {
    setIsCategoryDetail(value);
  }, []);

  const handleShowDND = React.useCallback(() => {
    setShowDND(s => !s);
  }, []);

  const doSpreedDownload = async filteredDelivery => {
    // REQUEST
    const respExport = await exportProducts(filteredDelivery);

    // Cria um URL para o arquivo baixado
    const url = window.URL.createObjectURL(new Blob([respExport]));
    const link = document.createElement('a');
    link.href = url;
    const currentDate = new Date().toISOString();
    const fileName = `products-${currentDate}.xlsx`;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    // LAYOUT - BOTAO
    setTimeout(() => {
      setExported('Exported!');
      setTimeout(() => {
        setExported('Export spreadsheet');
      }, 2000);
    }, 2000);
  };

  // FUNCAO QUE EXPORTA OS PRODUTOS EM PLANILHA
  const sendExportsProducts = React.useCallback(async () => {
    try {
      const urlToVerify = window.location.href;

      setExported('Exporting...');

      // SAPATOS - / SHOES
      if (urlToVerify.includes('shoes')) {
        // PRIMEIRO DELIVERY
        const first = {
          id: 1,
          products: [],
        };
        const responseFirst = await api.get(
          `/products/${dictIdDelivery[1]}?orderBy=delivery`
        );
        // let responseFirstPreFilter = responseFirst.data.filter(product => {
        //     return (
        //         product.style_collection === productObjectToFilter['delivery'] &&
        //         product.status === 'Available' &&
        //         product.capsula === 'MAIN COLLECTION'
        //     );
        // });
        const responseFirstPreFilter = responseFirst.data.filter(
          product =>
            product.status === 'Available' &&
            product.capsula !== 'MAIN COLLECTION' &&
            product.capsula !== 'PRE SPRING'
        );
        responseFirstPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[1]) {
            thisItem.delivery_id = `DELIVERY_1`;
            first.products.push(thisItem);
          }
        });

        // SEGUNDO DELIVERY
        const second = {
          id: 2,
          products: [],
        };
        const responseTwo = await api.get(
          `/products/${dictIdDelivery[2]}?orderBy=delivery`
        );
        // let responseTwoPreFilter = responseTwo.data.filter(product => {
        //     return (
        //         product.style_collection === productObjectToFilter['delivery'] &&
        //         product.status === 'Available' &&
        //         product.capsula === 'MAIN COLLECTION'
        //     );
        // });
        const responseTwoPreFilter = responseTwo.data.filter(
          product =>
            product.status === 'Available' &&
            product.capsula !== 'MAIN COLLECTION' &&
            product.capsula !== 'PRE SPRING'
        );
        responseTwoPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[2]) {
            thisItem.delivery_id = `DELIVERY_2`;
            second.products.push(thisItem);
          }
        });

        // TERCEIRO DELIVERY
        const third = {
          id: 3,
          products: [],
        };

        const responseTree = await api.get(
          `/products/${dictIdDelivery[3]}?orderBy=delivery`
        );
        // let responseTreePreFilter = responseTree.data.filter(product => {
        //     return (
        //         product.style_collection === productObjectToFilter['delivery'] &&
        //         product.status === 'Available' &&
        //         product.capsula === 'MAIN COLLECTION'
        //     );
        // });
        const responseTreePreFilter = responseTree.data.filter(
          product =>
            product.status === 'Available' &&
            product.capsula !== 'MAIN COLLECTION' &&
            product.capsula !== 'PRE SPRING'
        );
        responseTreePreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[3]) {
            thisItem.delivery_id = `DELIVERY_3`;
            third.products.push(thisItem);
          }
        });

        // CHOSED
        let filteredDelivery = null;
        let maxValue = null;

        // DELIVERYS UPDATED ORDER NUMBERS
        const firstUpdated = [];
        const secondUpdated = [];
        const thirdUpdated = [];

        // 1
        let countFirst = 1;
        first.products.forEach(item => {
          // if (item.category_name == "FOOTWEAR" || item.style_collection == "FOOTWEAR") {
          if (
            item.category_name == 'FOOTWEAR' ||
            item.style_collection == 'FOOTWEAR'
          ) {
            const thisItem = item;
            thisItem.order_by_delivery = countFirst;
            countFirst++;
            firstUpdated.push(thisItem);
          }
        });
        // --

        // 2
        maxValue = findMaxOrderByDelivery(firstUpdated);
        let countTwo = maxValue + 1;
        second.products.forEach(item => {
          // if (item.category_name == "FOOTWEAR" || item.style_collection == "FOOTWEAR") {
          if (
            item.category_name == 'FOOTWEAR' ||
            item.style_collection == 'FOOTWEAR'
          ) {
            const thisItem = item;
            thisItem.order_by_delivery = countTwo;
            countTwo++;
            secondUpdated.push(thisItem);
          }
        });
        // -

        // 3
        maxValue = findMaxOrderByDelivery(secondUpdated);
        let countTree = maxValue + 1;
        third.products.forEach(item => {
          // if (item.category_name == "FOOTWEAR" || item.style_collection == "FOOTWEAR") {
          if (
            item.category_name == 'FOOTWEAR' ||
            item.style_collection == 'FOOTWEAR'
          ) {
            const thisItem = item;
            thisItem.order_by_delivery = countTree;
            countTree++;
            thirdUpdated.push(thisItem);
          }
        });
        // -

        // SEM REGRA
        if (delivery_id == 1) {
          filteredDelivery = firstUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 2
        if (delivery_id == 2) {
          filteredDelivery = secondUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 3
        if (delivery_id == 3) {
          filteredDelivery = thirdUpdated;
        }

        // REQUEST
        const respExport = await exportProducts(filteredDelivery);

        // Cria um URL para o arquivo baixado
        const url = window.URL.createObjectURL(new Blob([respExport]));
        const link = document.createElement('a');
        link.href = url;
        const currentDate = new Date().toISOString();
        const fileName = `products-${currentDate}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // LAYOUT - BOTAO
        setTimeout(() => {
          setExported('Exported!');
          setTimeout(() => {
            setExported('Export spreadsheet');
          }, 2000);
        }, 2000);
      }

      // ROUPAS - /DELIVERY
      if (urlToVerify.includes('delivery')) {
        // PRIMEIRO DELIVERY
        const first = {
          id: 1,
          products: [],
        };
        const responseFirst = await api.get(
          `/products/${dictIdDelivery[1]}?orderBy=delivery`
        );
        const responseFirstPreFilter = organizeProductsToSpreed(
          responseFirst.data
        );
        responseFirstPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[1]) {
            thisItem.delivery_id = `DELIVERY_1`;
            first.products.push(thisItem);
          }
        });

        // SEGUNDO DELIVERY
        const second = {
          id: 2,
          products: [],
        };
        const responseTwo = await api.get(
          `/products/${dictIdDelivery[2]}?orderBy=delivery`
        );
        const responseTwoPreFilter = organizeProductsToSpreed(responseTwo.data);
        responseTwoPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[2]) {
            thisItem.delivery_id = `DELIVERY_2`;
            second.products.push(thisItem);
          }
        });

        // TERCEIRO DELIVERY
        const third = {
          id: 3,
          products: [],
        };
        const responseTree = await api.get(
          `/products/${dictIdDelivery[3]}?orderBy=delivery`
        );
        const responseTreePreFilter = organizeProductsToSpreed(
          responseTree.data
        );
        responseTreePreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[3]) {
            thisItem.delivery_id = `DELIVERY_3`;
            third.products.push(thisItem);
          }
        });

        // CHOSED
        let filteredDelivery = null;
        let maxValue = null;

        // DELIVERYS UPDATED ORDER NUMBERS
        const firstUpdated = [];
        const secondUpdated = [];
        const thirdUpdated = [];

        // 1
        let countFirst = 1;
        first.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countFirst;
          countFirst++;
          firstUpdated.push(thisItem);
        });
        // --

        // 2
        maxValue = findMaxOrderByDelivery(firstUpdated);
        let countTwo = maxValue + 1;
        second.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countTwo;
          countTwo++;
          secondUpdated.push(thisItem);
        });
        // -

        // 3
        maxValue = findMaxOrderByDelivery(secondUpdated);
        let countTree = maxValue + 1;
        third.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countTree;
          countTree++;
          thirdUpdated.push(thisItem);
        });
        // -

        // SEM REGRA
        if (delivery_id == 1) {
          filteredDelivery = firstUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 2
        if (delivery_id == 2) {
          filteredDelivery = secondUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 3
        if (delivery_id == 3) {
          filteredDelivery = thirdUpdated;
        }

        // REQUEST
        const respExport = await exportProducts(filteredDelivery);

        // Cria um URL para o arquivo baixado
        const url = window.URL.createObjectURL(new Blob([respExport]));
        const link = document.createElement('a');
        link.href = url;
        const currentDate = new Date().toISOString();
        const fileName = `products-${currentDate}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // LAYOUT - BOTAO
        setTimeout(() => {
          setExported('Exported!');
          setTimeout(() => {
            setExported('Export spreadsheet');
          }, 2000);
        }, 2000);
      }

      // SWIN
      if (urlToVerify.includes('swimwear')) {
        // PRIMEIRO DELIVERY
        const first = {
          id: 1,
          products: [],
        };
        const responseFirst = await api.get(
          `/products/${dictIdDelivery[1]}?orderBy=delivery`
        );
        const responseFirstPreFilter = responseFirst.data.filter(
          product =>
            product.style_collection ===
              productObjectToFilter[currentCollection] &&
            product.status === 'Available'
        );
        responseFirstPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[1]) {
            thisItem.delivery_id = `DELIVERY_1`;
            first.products.push(thisItem);
          }
        });

        // SEGUNDO DELIVERY
        const second = {
          id: 2,
          products: [],
        };
        const responseTwo = await api.get(
          `/products/${dictIdDelivery[2]}?orderBy=delivery`
        );
        const responseTwoPreFilter = responseTwo.data.filter(
          product =>
            product.style_collection ===
              productObjectToFilter[currentCollection] &&
            product.status === 'Available'
        );
        responseTwoPreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[2]) {
            thisItem.delivery_id = `DELIVERY_2`;
            second.products.push(thisItem);
          }
        });

        // TERCEIRO DELIVERY
        const third = {
          id: 3,
          products: [],
        };
        const responseTree = await api.get(
          `/products/${dictIdDelivery[3]}?orderBy=delivery`
        );
        const responseTreePreFilter = responseTree.data.filter(
          product =>
            product.style_collection ===
              productObjectToFilter[currentCollection] &&
            product.status === 'Available'
        );
        responseTreePreFilter.forEach(item => {
          const thisItem = item;
          if (item.delivery_id === dictIdDelivery[3]) {
            thisItem.delivery_id = `DELIVERY_3`;
            third.products.push(thisItem);
          }
        });

        // CHOSED
        let filteredDelivery = null;
        let maxValue = null;

        // DELIVERYS UPDATED ORDER NUMBERS
        const firstUpdated = [];
        const secondUpdated = [];
        const thirdUpdated = [];

        // 1
        let countFirst = 1;
        first.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countFirst;
          countFirst++;
          firstUpdated.push(thisItem);
        });
        // --

        // 2
        maxValue = findMaxOrderByDelivery(firstUpdated);
        let countTwo = maxValue + 1;
        second.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countTwo;
          countTwo++;
          secondUpdated.push(thisItem);
        });
        // -

        // 3
        maxValue = findMaxOrderByDelivery(secondUpdated);
        let countTree = maxValue + 1;
        third.products.forEach(item => {
          if (
            item.category_name != 'FOOTWEAR' &&
            item.style_collection != 'FOOTWEAR'
          ) {
          }
          const thisItem = item;
          thisItem.order_by_delivery = countTree;
          countTree++;
          thirdUpdated.push(thisItem);
        });
        // -

        // console.log("1: ", firstUpdated);
        // console.log("2: ", secondUpdated);
        // console.log("3: ", thirdUpdated);
        const match = window.location.pathname.match(/\/swimwear\/(\d+)\/view/);

        // SEM REGRA
        // if (delivery_id == 1) {
        if (match[1] == 1) {
          filteredDelivery = firstUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 2
        if (match[1] == 2) {
          filteredDelivery = secondUpdated;
        }

        // REGRA APLICADADA SOMENTE PARA 3
        if (match[1] == 3) {
          filteredDelivery = thirdUpdated;
        }

        // DOWNLOAD
        doSpreedDownload(filteredDelivery);
      }
    } catch (error) {
      console.error('Error exporting products:', error);
      setExported('Export spreadsheet');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delivery_id, currentCollection, setExported]);

  function organizeProductsToSpreed(thisProducts) {
    try {
      const orderedProducts = [];
      const capsulaProducts = [];
      const preSpringProducts = [];

      const productsFiltered = thisProducts.filter(
        product =>
          product.style_collection === productObjectToFilter.delivery &&
          product.status === 'Available'
      );

      productsFiltered.forEach(product =>
        product.status === 'Available'
          ? product.capsula === 'MAIN COLLECTION'
            ? orderedProducts.push(product)
            : product.capsula === 'PRE SPRING'
            ? preSpringProducts.push(product)
            : capsulaProducts.push(product)
          : null
      );

      const allProducts = [
        ...orderedProducts,
        ...capsulaProducts,
        ...preSpringProducts,
      ];

      return allProducts;
    } catch (e) {
      console.log('Erro aqui: ', e);
    }
  }

  function findMaxOrderByDelivery(list) {
    return list.reduce((max, item) => {
      const value = Number(item.order_by_delivery);
      return value > max ? value : max;
    }, -Infinity);
  }

  // FUNCAO QUE EXPORTA AS IMAGENS EM ZIP
  const sendExportsImages = React.useCallback(async () => {
    try {
      setBtnText('Wait please. exporting images...');
      const findJustOk = imagesToExport.filter(item => {
        return item !== '';
      });

      const response = await exportImages(findJustOk);
      const { zipUrl } = response;

      const link = document.createElement('a');
      link.href = zipUrl;
      link.download = 'exported_images.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setBtnText('Export success!');
      setTimeout(() => {
        setBtnText('Export Images');
      }, 3500);
    } catch (error) {
      console.error('Error exporting products:', error);
    }
  }, [imagesToExport, setBtnText]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const backgroundImageObject = React.useMemo(
    () => ({
      view: {
        delivery: `url(${
          configState.deliveries[+delivery_id - 1]?.bgWeb
        }) top/cover`,
        swimwear: `url(${
          configState.swimwear[+delivery_id - 1]?.bgWeb
        }) top/cover`,
        shoes: `url(${configState.shoes[+delivery_id - 1]?.bgWeb}) top/cover`,
        men: `url(https://storage.googleapis.com/showroom-bucket-images/SS24/Delivery1/Male/BG/Delivery1_BG.jpg) top/cover`,
      },
      category: {
        delivery: '#fff',
        swimwear: '#fff',
        shoes: '#fff',
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [configState, delivery_id, currentCollection]
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const containerRef = useRef(null);

  const listenScrollEvent = () => {
    if (window.scrollY >= 0 && window.scrollY <= 100) {
      setBg(true);
    }
    if (window.scrollY > 101) {
      setBg(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = $(window).scrollTop();

      const bgColor =
        scrollY >= 0 && scrollY <= 100
          ? backgroundImageObject[view][currentCollection]
          : '#fff';

      $('#deliveryBanner').css({
        background: bgColor,
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    $(window).on('scroll', handleScroll);

    // Chama uma vez ao montar para aplicar o estilo inicial
    handleScroll();

    return () => {
      $(window).off('scroll', handleScroll);
    };
  }, [delivery_id, view, currentCollection, backgroundImageObject]);

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
    return () => window.removeEventListener('scroll', listenScrollEvent);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [delivery_id]);

  return (
    <>
      <Media
        queries={{
          small: '(max-width: 1050px)',
          large: '(min-width: 1051px)',
        }}
      >
        {matches => (
          <>
            {matches.small && <DeliveriesMobile />}
            {matches.large && (
              <>
                <HeaderView
                  handleShowDND={handleShowDND}
                  handleExportProducts={sendExportsProducts}
                  handleExportImages={sendExportsImages}
                  isCategoryDetail={isCategoryDetail}
                  isDelivery
                  open={handleClickOpen}
                  bg={bg}
                />{' '}
                <Grid
                  ref={containerRef}
                  container
                  direction="row"
                  justifyContent="center"
                  style={{ position: 'relative', top: 77 }}
                  id="deliveryBanner"
                >
                  <Grid
                    style={{
                      width: '100%',
                      paddingTop: 0,
                    }}
                  >
                    <Grid
                      style={{
                        paddingBottom: 102,
                      }}
                    >
                      {view === 'view' && (
                        <DeliveryView
                          showDND={showDND}
                          handleShowDND={handleShowDND}
                          handleExportProducts={sendExportsProducts}
                          bg={bg}
                        />
                      )}
                      {view === 'smiley' && <TakeAwayView bg={bg} />}

                      {view === 'category' && (
                        <CategoryView
                          showDND={showDND}
                          handleShowDND={handleShowDND}
                          handleExportProducts={sendExportsProducts}
                          handleIsCategoryDetail={handleIsCategoryDetail}
                        />
                      )}
                      {view === 'print' && <PrintView />}
                    </Grid>
                  </Grid>
                </Grid>
                <ModalCollection open={open} handleClose={handleClose} />
                <LeftLateralBar
                  DELIVERIES={configState.deliveries}
                  delivery={delivery_id}
                  by={view}
                  bg={bg}
                />
                {/* <RightLateralBar delivery={delivery_id} by={view} bg={bg} /> */}
              </>
            )}
          </>
        )}
      </Media>
    </>
  );
}

export default Deliveries;
